import { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SideBox from "../pages/SideBox";

// css
import "../css/EurekaTrend.css";

// img
import eurekaVideo from "../assets/video/solutions_Eureka_video.mp4";

import icon1 from "../assets/img/eureka_icon1.png";
import icon2 from "../assets/img/eureka_icon2.png";
import icon3 from "../assets/img/eureka_icon3.png";
import leftArrow from "../assets/img/eureka_left.png";
import rightArrow from "../assets/img/eureka_right.png";
import sec2_icon1 from "../assets/img/eureka_sec2_icon1.png";
import sec2_icon2 from "../assets/img/eureka_sec2_icon2.png";
import sec2_icon3 from "../assets/img/eureka_sec2_icon3.png";
import sec2_icon4 from "../assets/img/eureka_sec2_icon4.png";
import sec2_icon5 from "../assets/img/eureka_sec2_icon5.png";
import line01 from "../assets/img/sec2_line01.png";
import line02 from "../assets/img/sec2_line02.png";
import slide01 from "../assets/img/eureka_slide_01.png";
import slide02 from "../assets/img/eureka_slide_02.png";
import slide03 from "../assets/img/eureka_slide_03.png";
import slide04 from "../assets/img/eureka_slide_04.png";
import slide05 from "../assets/img/eureka_slide_05.png";
import slide06 from "../assets/img/eureka_slide_06.png";
import slide07 from "../assets/img/eureka_slide_07.png";
import slide09 from "../assets/img/eureka_slide_09.png";
import slide10 from "../assets/img/eureka_slide_10.png";
import slide13 from "../assets/img/eureka_slide_13.png";
import slide14 from "../assets/img/eureka_slide_14.png";
import sec4Icon1 from "../assets/img/eureka_sec4_icon1.png";
import sec4Icon2 from "../assets/img/eureka_sec4_icon2.png";
import sec4Icon3 from "../assets/img/eureka_sec4_icon3.png";
import sec4Icon4 from "../assets/img/eureka_sec4_icon4.png";
import sec4Icon5 from "../assets/img/eureka_sec4_icon5.png";
import sec4Icon6 from "../assets/img/eureka_sec4_icon6.png";
import sec4Icon7 from "../assets/img/eureka_sec4_icon7.png";
import sec4Icon8 from "../assets/img/eureka_sec4_icon8.png";
import sec4Icon9 from "../assets/img/eureka_sec4_icon9.png";
import dotLine from "../assets/img/sec4_dot_line.png";
import downIcon1 from "../assets/img/down_icon1.png";
import downIcon2 from "../assets/img/down_icon2.png";
import downIcon3 from "../assets/img/down_icon3.png";
import downIcon4 from "../assets/img/down_icon4.png";

export default function EurekaBrain() {
  const [activeTab, setActiveTab] = useState("tab1");

  const sliderSettings = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    arrows: true,
    dots: true,
    autoplay: false,
    autoplaySpeed: 2000,
    pauseOnHover: true,
  };

  return (
    <div className="eureka_main">
      <SideBox />

      <header className="eureka_header">
        <div className="bg_black"></div>
        <video muted autoPlay loop>
          <source src={eurekaVideo} type="video/mp4" />
        </video>

        <div className="header_text center">
          <div className="text">
            <h3>데이터 수집을 통해 잠재된 비즈니스 가치를 발견하세요​</h3>
            <h1>
              이커머스 데이터 자동화 솔루션
              <br />
              EurekaBrain
            </h1>
          </div>

          <div className="header_btn">
            <a
              href="http://file.rbrain.co.kr/2025-09-26T05-39-01-493Z-2023_eureka_sevice.pdf"
              className="btn_left"
              target="_blank"
              rel="noreferrer"
            >
              서비스 소개서
            </a>
            <a
              href="https://rbrain.co.kr/company/support"
              target="_blank"
              rel="noreferrer"
            >
              이용 문의
            </a>
          </div>

          <div id="scroll">
            <p>Scroll down</p>
            <div onClick={(e) => e.preventDefault()} className="scroll">
              <span></span>
            </div>
          </div>
        </div>
      </header>

      <main>
        {/* Section 1 */}
        <section id="sec1">
          <div className="center">
            <div>
              <h3>EurekaBrain</h3>
              <h2>서비스 소개</h2>
            </div>
            <div className="sec1_box">
              <div className="box">
                <img src={icon1} alt="아이콘 이미지아이콘 이미지" />
                <p>
                  <span>365일 24시간 상품 가격과 정보</span>를<br />
                  매일 모니터링할 수 있다면​
                </p>
              </div>
              <div className="box">
                <img src={icon2} alt="아이콘 이미지아이콘 이미지" />
                <p>
                  마케팅 전략을 위한 방대한 데이터를​
                  <br />
                  <span>자동으로 수집</span>할 수 있다면​​
                </p>
              </div>
              <div className="box">
                <img src={icon3} alt="아이콘 이미지아이콘 이미지" />
                <p>
                  <span>지나간 과거 데이터</span>를 원할 때​
                  <br />
                  바로 확인할 수 있다면​​
                </p>
              </div>
            </div>
            <div>
              <p className="main_text">
                <img
                  src={leftArrow}
                  alt="아이콘 이미지화살표 이미지"
                  className="arr_left"
                />
                지금 여러분의 브랜드 수익성은 어떻게 달라졌을까요?
                <img
                  src={rightArrow}
                  alt="아이콘 이미지화살표 이미지"
                  className="arr_right"
                />
              </p>
              <p className="sub_text">
                소비재 산업은 상품과 온라인 채널이 다양해지고 고객 중심 대응 및
                경쟁 강화 등의 <br />
                극적인 변화를 맞이하여 성장을 넘어선 생존을 위한 적극적인 대응이
                필요합니다.
                <br /> <br />
                그러나 여러 이커머스 사이트에서 발생하는 데이터 관리, 고객
                피드백과 경쟁 브랜드의 활동을 <br />
                모두 대응하기에는 인력, 시간, 돈의 제약으로 어려움을 겪고 있는
                것이 현실입니다.
              </p>

              <div className="box2_bg">
                <p>
                  <span>EurekaBrain</span>은 이커머스 시장에서 소비재 브랜드가
                  지속적으로 선제 대응할 수 있도록
                  <br />
                  데이터를 빠르게 수집하고 분석 및 대응을 자동화할 수 있는
                  <span>‘데이터 자동화 솔루션’</span> 으로​
                  <br />
                  자사 브랜드를 쉽고 빠르게, 지속적으로 성장시키는 것을 목표로
                  합니다.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Section 2 */}
        <section id="sec2">
          <div className="center">
            <div>
              <h3>EurekaBrain</h3>
              <h2>주요 기능</h2>
            </div>
            <div className="sec2_box">
              <div className="box">
                <div className="num">01</div>
                <img src={sec2_icon1} alt="아이콘 이미지" />
                <p>
                  국내 주요
                  <br />
                  이커머스 사이트에서
                  <br />
                  상품 가격 자동 수집​​
                </p>
              </div>
              <div className="box">
                <div className="num">02</div>
                <img src={sec2_icon2} alt="아이콘 이미지" />
                <p>
                  가격 변동 추이를
                  <br />
                  모니터링하여
                  <br />
                  대시보드로 제공​​​
                </p>
              </div>
              <div className="box" style={{ marginRight: "20px" }}>
                <div className="num">03</div>
                <img src={sec2_icon3} alt="아이콘 이미지" />
                <p>
                  상품별
                  <br />
                  광고 위치 및<br />
                  노출 빈도 모니터링​​
                </p>
              </div>
              <div className="box">
                <div className="num">04</div>
                <img src={sec2_icon4} alt="아이콘 이미지" />
                <p>
                  상품평 개수,
                  <br />
                  평점 등<br />
                  소비자 리뷰 분석​​​​
                </p>
              </div>
              <div className="box">
                <div className="num">05</div>
                <img src={sec2_icon5} alt="아이콘 이미지" />
                <p>
                  최저가, 판매 추이 등<br />
                  실시간 모니터링 및<br />
                  Alert 제공​​
                </p>
              </div>
            </div>

            <div className="sec2_box2_wrap">
              <div className="box2_left">
                <div className="box2_main_text">Technology</div>
                <div>
                  <div className="cE6F9FF_wrap">
                    <div className="cE6F9FF">
                      RPA
                      <br />
                      (Robotic Process Automation,
                      <br />
                      업무 처리 자동화)
                    </div>
                    <div className="cE6F9FF">
                      web crawling
                      <br />
                      (데이터 자동 수집)
                    </div>
                  </div>
                  <div className="cE6F9FF_wrap">
                    <div className="cE6F9FF">
                      언제 어디서나 ​사용 가능한​
                      <br />
                      SaaS 방식 서비스​
                    </div>
                    <div className="cE6F9FF">
                      Multi Cloud를 지원하는​
                      <br />
                      Cloud Native Platform
                    </div>
                  </div>
                </div>
              </div>

              <div className="box2_center">
                <img src={line01} alt="아이콘 이미지라인 이미지" />
                <div>
                  Eureka
                  <br />
                  Brain
                </div>
                <img src={line02} alt="아이콘 이미지라인 이미지" />
              </div>

              <div className="box2_right">
                <div>
                  <div className="box2_main_text2">Service</div>
                  <div className="cE9EBFF">상품 데이터 수집​</div>
                  <div className="cE9EBFF">노출 순위 확인​</div>
                  <div className="cE9EBFF">소비자 리뷰 분석​</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section 3 */}
        <section id="sec3">
          <div className="center">
            <div>
              <h3>EurekaBrain</h3>
              <h2>서비스 특징</h2>
            </div>

            <div className="tab_menu">
              <ul className="tab_list">
                {/* Tab 1 */}
                <li className={activeTab === "tab1" ? "is_on" : ""}>
                  <button className="btn" onClick={() => setActiveTab("tab1")}>
                    상품 데이터 수집
                  </button>
                  {activeTab === "tab1" && (
                    <div id="tab1" className="cont">
                      <div className="tab_text">
                        <p>
                          <span className="dot"></span>쿠팡, 네이버, 지마켓,
                          11번가, 옥션 등 국내 주요 이커머스 사이트에서 자사 및
                          경쟁사의 상품 가격을 고속으로 수집합니다.
                        </p>
                        <p>
                          <span className="dot"></span>상품 가격은 상품 고유의
                          최소 단위(미터, 리터, 개 등)로 수집하여 동일한 스펙
                          기준으로 상품 비교가 가능합니다.
                        </p>
                        <p>
                          <span className="dot"></span>배송비 및 할인쿠폰을
                          적용한 상품별 최저가 확인이 가능합니다.
                        </p>
                        <p>
                          <span className="dot"></span>일별 가격, 주간 평균 가격
                          등 가격 변동 추이를 모니터링하여 대시보드로
                          제공합니다.
                        </p>
                        <p>
                          <span className="dot"></span>특정 상품의 최저가 도달
                          시 알림 메일이 발송됩니다.
                        </p>
                      </div>
                      <Slider {...sliderSettings}>
                        <div>
                          <img
                            src={slide01}
                            alt="아이콘 이미지슬라이드 이미지"
                          />
                        </div>
                        <div>
                          <img
                            src={slide02}
                            alt="아이콘 이미지슬라이드 이미지"
                          />
                        </div>
                        <div>
                          <img
                            src={slide03}
                            alt="아이콘 이미지슬라이드 이미지"
                          />
                        </div>
                        <div>
                          <img
                            src={slide04}
                            alt="아이콘 이미지슬라이드 이미지"
                          />
                        </div>
                      </Slider>
                    </div>
                  )}
                </li>

                {/* Tab 2 */}
                <li className={activeTab === "tab2" ? "is_on" : ""}>
                  <button className="btn" onClick={() => setActiveTab("tab2")}>
                    노출 순위 확인
                  </button>
                  {activeTab === "tab2" && (
                    <div id="tab2" className="cont">
                      <div className="tab_text">
                        <p>
                          <span className="dot"></span>사이트별 광고 위치를
                          PC/Mobile로 구분하여 광고 노출 순위 및 노출빈도를
                          확인할 수 있습니다.
                        </p>
                        <p>
                          <span className="dot"></span>행사 카테고리에 있는 상품
                          및 노출순위를 별도로 수집하여, 행사 전략과 행사 시
                          기존 가격 대비 할인율 범위를 파악할 수 있습니다.
                        </p>
                        <p>
                          <span className="dot"></span>일별 순위 및 주간 평균
                          순위 변동 추이를 모니터링하여 대시보드로 제공합니다.
                        </p>
                        <p>
                          <span className="dot"></span>노출 순위(랭킹)를 통해
                          커머스별 광고 효과를 분석할 수 있습니다.
                        </p>
                      </div>
                      <Slider {...sliderSettings}>
                        <div>
                          <img
                            src={slide05}
                            alt="아이콘 이미지슬라이드 이미지"
                          />
                        </div>
                        <div>
                          <img
                            src={slide06}
                            alt="아이콘 이미지슬라이드 이미지"
                          />
                        </div>
                        <div>
                          <img
                            src={slide07}
                            alt="아이콘 이미지슬라이드 이미지"
                          />
                        </div>
                      </Slider>
                    </div>
                  )}
                </li>

                {/* Tab 3 */}
                <li className={activeTab === "tab3" ? "is_on" : ""}>
                  <button className="btn" onClick={() => setActiveTab("tab3")}>
                    소비자 리뷰 분석
                  </button>
                  {activeTab === "tab3" && (
                    <div id="tab3" className="cont">
                      <div className="tab_text">
                        <p>
                          <span className="dot"></span>리뷰개수 및 평점을
                          실시간으로 수집합니다.
                        </p>
                        <p>
                          <span className="dot"></span>수집한 소비자 리뷰를 통해
                          Trend 및 Insight를 파악하여 마케팅 전략을 수립할 수
                          있습니다.
                        </p>
                      </div>
                      <Slider {...sliderSettings}>
                        <div>
                          <img
                            src={slide09}
                            alt="아이콘 이미지슬라이드 이미지"
                          />
                        </div>
                        <div>
                          <img
                            src={slide10}
                            alt="아이콘 이미지슬라이드 이미지"
                          />
                        </div>
                      </Slider>
                    </div>
                  )}
                </li>

                {/* Tab 4 */}
                <li className={activeTab === "tab4" ? "is_on" : ""}>
                  <button className="btn" onClick={() => setActiveTab("tab4")}>
                    스마트 관제
                  </button>
                  {activeTab === "tab4" && (
                    <div id="tab4" className="cont">
                      <div className="tab_text">
                        <p>
                          <span className="dot"></span>정보보호를 위해 모든
                          데이터는 암호화되어 안전하게 관리됩니다.
                        </p>
                      </div>
                      <Slider {...sliderSettings}>
                        <div>
                          <img
                            src={slide13}
                            alt="아이콘 이미지슬라이드 이미지"
                          />
                        </div>
                        <div>
                          <img
                            src={slide14}
                            alt="아이콘 이미지슬라이드 이미지"
                          />
                        </div>
                      </Slider>
                    </div>
                  )}
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* Section 4 */}
        <section id="sec4">
          <div className="center">
            <div>
              <h3>EurekaBrain</h3>
              <h2>기대효과</h2>
            </div>

            <div>
              <div>
                <div className="box_wrap">
                  <div className="box">
                    <img src={sec4Icon1} alt="아이콘 이미지아이콘 이미지" />
                    <p>
                      상품별 가격 추이 그래프를 통해 자사 및 경쟁사 주요 제품의
                      Daily 가격과 Trend 파악​
                    </p>
                  </div>
                  <div className="box">
                    <img src={sec4Icon2} alt="아이콘 이미지아이콘 이미지" />
                    <p>
                      실시간 데이터 수집을 통한 최저가 경쟁에 적극적으로 대응​​
                    </p>
                  </div>
                </div>

                <div className="box_wrap">
                  <div className="box">
                    <img src={sec4Icon3} alt="아이콘 이미지아이콘 이미지" />
                    <p>
                      특정 상품의 가격 변동 추이를 확인하여 상품 가격 결정 시
                      가이드 역할 가능​​
                    </p>
                  </div>
                  <div className="box">
                    <img src={sec4Icon4} alt="아이콘 이미지아이콘 이미지" />
                    <p>
                      랭킹 하락 추세인 자사 제품을 파악하여 대처방안을 수립하는
                      데 도움​​
                    </p>
                  </div>
                </div>

                <div className="box_wrap">
                  <div className="box">
                    <img src={sec4Icon5} alt="아이콘 이미지아이콘 이미지" />
                    <p>
                      랭킹 상승 추세인 경쟁사 제품을 파악하여 원인을 분석하고
                      Business Model로 활용​​
                    </p>
                  </div>
                  <div className="box">
                    <img src={sec4Icon6} alt="아이콘 이미지아이콘 이미지" />
                    <p>
                      상품 가격 외 할인 여부, 배송비 등 구매 결정 요소에 대한
                      통찰 제공​
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <div className="dot_line">
                  <img src={dotLine} alt="아이콘 이미지도트 라인 이미지" />
                </div>

                <div>
                  <div className="box2_wrap">
                    <div className="box2">
                      <img src={sec4Icon7} alt="아이콘 이미지아이콘 이미지" />
                      <h5 className="c7959AE">인건비 효율화​</h5>
                      <p>365일 24시간 데이터 수집 가능​</p>
                    </div>
                    <div className="box2">
                      <img src={sec4Icon8} alt="아이콘 이미지아이콘 이미지" />
                      <h5 className="c5069C1">마켓 인사이트 확보​</h5>
                      <p>마케팅 전략 설계를 위한 베이스로 활용​</p>
                    </div>
                    <div className="box2">
                      <img src={sec4Icon9} alt="아이콘 이미지아이콘 이미지" />
                      <h5 className="c327EA8">데이터 가치 발굴​</h5>
                      <p>대량으로 자동 수집된 과거 데이터 분석​</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section 5 */}
        <section id="sec5">
          <div className="center">
            <div>
              <h3>EurekaBrain</h3>
              <h2>서비스 소개영상</h2>
            </div>

            <div>
              <iframe
                width="950"
                height="534"
                src="https://www.youtube.com/embed/eFv9zayaHjA?si=5OP3z5bYFtZepPyS"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>

              <div className="down_btn">
                <a
                  href="http://file.rbrain.co.kr/2025-09-26T05-39-40-653Z-eurekaBrain_Manual.pdf"
                  className="btn_left"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={downIcon1} alt="아이콘 이미지" />
                  <p>
                    <span>매뉴얼 </span>다운로드
                  </p>
                  <img src={downIcon2} alt="아이콘 이미지" />
                </a>

                <a
                  href="https://rbrain.co.kr/company/support"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={downIcon3} alt="아이콘 이미지" />
                  <p style={{ color: "#6259cf" }}>비용 문의</p>
                  <img
                    src={downIcon4}
                    alt="아이콘 이미지"
                    style={{ transform: "rotate(270deg)" }}
                  />
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
